import { create } from 'zustand';

import { type ShopifyDeliverResponse } from '~/constants/ShopifyDeliverTypes';

export type DeliveryState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'success'; initiated: ShopifyDeliverResponse['initiated']; errors: ShopifyDeliverResponse['errors'] }
  | { status: 'error'; errors: ShopifyDeliverResponse['errors'] };

type DeliveryStore = {
  deliveryState: DeliveryState;
  setDeliveryState: (state: DeliveryState) => void;
};

export const useDeliveryStore = create<DeliveryStore>((set) => ({
  deliveryState: { status: 'idle' },
  setDeliveryState: (deliveryState) => set({ deliveryState }),
}));
